// The site sets one cookie (the login session) and nothing else needs consent
// under GDPR/ePrivacy — its own count of visits keeps nothing that names a
// reader — so this is a notice, not a consent gate. Dismissal is
// remembered in localStorage, same pattern as reader settings.
//
// On a page with the admin's bar it sits on top of the bar, not over it: laid
// over the bar, it hid the Edit button until the notice was dismissed.
import { useState } from "react";
import { Link } from "wouter";
import { useBottomBarHeight } from "./BottomBar";

const LS_KEY = "bu.cookieNoticeDismissed";

export function CookieNotice() {
  const [dismissed, setDismissed] = useState(() => localStorage.getItem(LS_KEY) === "1");
  const lift = useBottomBarHeight();

  if (dismissed) return null;

  return (
    <div
      role="region"
      aria-label="Cookie notice"
      style={{ bottom: lift }}
      className="fixed inset-x-0 bottom-0 z-40 border-t border-rule bg-paper px-4 py-3 shadow-pop"
    >
      <div className="mx-auto flex max-w-[960px] flex-wrap items-center gap-3 text-[13px] text-ink-2">
        <p className="min-w-[240px] flex-1">
          This site uses one cookie to keep you signed in, and stores your reading preferences in your browser. It
          counts its own visits, with no cookie and no third party. No ads, nothing shared with anyone else.{" "}
          <Link href="/privacy" className="text-accent">Read more</Link>
        </p>
        <button
          onClick={() => {
            localStorage.setItem(LS_KEY, "1");
            setDismissed(true);
          }}
          className="shrink-0 rounded-md border border-ink px-3 py-1.5 text-[13px] text-ink"
        >
          Got it
        </button>
      </div>
    </div>
  );
}
